import React, { useRef, useState, useContext } from "react";
import IdleTimer from "react-idle-timer";
import InactiveTimeoutDialog from "./inactiveTimeoutDialog";
import { SystemVariable } from '../contexts/systemVariableContext';
import { TransactionTime } from './transactionTime';
let idleInterval;

const InactiveTimeout = ({ disContinue }) => {
    const { inactiveTime } = useContext(SystemVariable);
    const [timeoutModalOpen, setTimeoutModalOpen] = useState(false);
    const [idleTime, setIdleTime] = useState(0);
    const idleTimer = useRef(null);
    const inactiveTimeInSecs = inactiveTime * 60 * 1000;

    const clearInactiveInterval = () => {
        clearInterval(idleInterval);
    };

    const handleDisContinue = async (isTimedOut = false) => {
        try {
            setTimeoutModalOpen(false);
            clearInactiveInterval();
            disContinue();
        } catch (err) {
            console.error(err);
        }
    };

    const handleContinue = () => {
        setTimeoutModalOpen(false);
        clearInactiveInterval();
        TransactionTime.keepRun();
    };

    const onActive = () => {
        if (!timeoutModalOpen) {
            clearInactiveInterval();
        }
    };

    const onIdle = () => {
        if (!timeoutModalOpen) {
            let idleTimeInMinutes = inactiveTime;
            let seconds = 0;
            TransactionTime.warning();
            setTimeoutModalOpen(true);
            setIdleTime(idleTimeInMinutes);
            idleInterval = setInterval(() => {
                seconds++;
                if ((seconds % 60) === 0) {
                    setIdleTime(idleTimeInMinutes++);
                }
            }, 1000);
        }
    };

    return (
        <>
            <IdleTimer
                ref={idleTimer}
                onActive={onActive}
                onIdle={onIdle}
                debounce={250}
                timeout={inactiveTimeInSecs}
            />
            <InactiveTimeoutDialog
                open={timeoutModalOpen}
                idleTime={idleTime}
                onDisContinue={() => handleDisContinue(false)}
                onContinue={handleContinue}
            />
        </>
    );
}

export default InactiveTimeout;
